import { createAction } from '@reduxjs/toolkit'

export const crmStateSaved = createAction('nova/crmStateSaved')
